/* eslint-disable no-unused-vars */
import Log from '@/utils/log/log'
import { setCookie } from '@/utils/tool'
import { login, loginGt, logout } from '@/services/user'

const state = () => {
  return {
    token: '',
    is_corp_user: 0,
    type: 0,
    language: '',
    user_info: {},
    dpsLimit: {
      // 提醒DPS额度不足
      type: 0, // dps张数 <= 10张/人时: 1, 0<dps<10, 2 dps=0, 0 dps>10，type为1或2 显示不同提示文案
      show: false, // 是否显示 type>0 显示，或者4小时再次请求时，判断是否显示
      lastTime: 0, // 名片夹或者管理页面上次请求时间，4小时请求一次接口，符合type>0 则显示
      contact: ''
    },
    checkReqConfig: {
      // 检查请求是否需要再次请求，有些情况下，请求过一次，获取到状态之后，在下次登录之前，一般不需要再次发起请求，这类请求是否要再次发送请求，在这里处理逻辑，减少无用的请求
      no_need_check_first_login: 0 // check_first_login接口
    },
    msgData: {
      apply_num: 0,
      hrchange_num: 0,
      share_num: 0,
      upload_card_num: 0,
      task_num: 0
    },
    isWhiteListUser: true,
    isChZnAccount: true, // 是否是国内账户
    messageCount: 0, // 已读的消息数
    card_pageSize: 0,
    isBatchDeleting: 0, // 是否正在执行批量删除
    edmMsg: {
      show_edm_point: 0, //营销邮件红点提示
      show_edm_pop: 0 //营销邮件弹窗
    }
  }
}

const actions = {
  login({ commit }, formData) {
    return new Promise((resolve, reject) => {
      login(formData)
        .then(data => {
          console.log('login data', data)
          if (data.errno == 0) {
            commit('setUser', data.data)
            if (__DEV__) {
              setCookie('S2', data.data.token, 30)
            }
            resolve(data)
          } else {
            reject(data.errno)
          }
        })
        .catch(e => reject(e?.errno || ''))
    })
  },
  loginGt({ commit }, formData) {
    return new Promise((resolve, reject) => {
      loginGt(formData)
        .then(data => {
          console.log('login gt data', data)
          if (data.errno == 0) {
            commit('setUser', data.data)
            if (__DEV__) {
              setCookie('S2', data.data.token, 30)
            }
            resolve(data)
          } else {
            reject(data)
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(data => {
        if (data.errno) {
          reject(data.errno)
        } else {
          commit('clearUserInfo')
          resolve()
        }
      })
    })
  }
}

const mutations = {
  setUser(state, data) {
    if (state.token === data.token) {
      state.user_info = {
        ...state.user_info,
        ...data.user_info
      }
    } else {
      state.user_info = data.user_info
    }
    Log.setUserId(state.user_info.user_id || '')
    // 国外用户购买或者升级国内套餐，白名单用户正常购买付费
    const whiteListUser = []
    const { group_id = 0, corp_gid = 0, user_id = 0 } = data.user_info
    state.isChZnAccount = corp_gid.toString().startsWith('1') // corp_gid: 1开头的是国内用户，2开头的国外 屏蔽国内用户访问outlook通讯录功能
    // state.isWhiteListUser = corp_id === 466765 || /^1/g.test(group_id)
    state.token = data.token
    state.is_corp_user = data.is_corp_user
    state.type = data.type
  },
  setToken(state, token) {
    state.token = token
    setCookie('S2', token, 30)
    console.log(state)
  },
  updateUser(state, data) {
    if (data.user_crfast_left) {
      state.user_info.user_crfast_left = data.user_crfast_left
    }
    if (data.privilege_info) {
      state.user_info.privilege_info = data.privilege_info
    }
    if (data.purchase_product) {
      state.user_info.purchase_product = data.purchase_product
    }
    if (data.user_crfast_total != undefined) {
      state.user_info.user_crfast_total = data.user_crfast_total
    }
  },
  saveLanguage(state, data) {
    state.language = data
  },
  clearUserInfo(state) {
    state.token = ''
    state.is_corp_user = 0
    state.type = 0
    state.messageCount = 0
    state.user_info = {}
    Log.setUserId('')
    localStorage.resetLang = ''
    setCookie('S2', '', -1)
    state.dpsLimit = {
      type: 0,
      show: false,
      lastTime: 0,
      contact: ''
    }
    state.checkReqConfig = {
      no_need_check_first_login: 0
    }
  },
  messageCount(state, data) {
    state.messageCount = data
  },
  setValue(state, payload) {
    state[payload.key] = payload.value
  },
  setMsgNum(state, data) {
    state.msgData = data
  },
  setDpsLimit(state, data) {
    console.warn('---------dps弹窗data-----', data)
    state.dpsLimit = Object.assign({}, state.dpsLimit, data)
  },
  clearDpsLimit() {
    state.dpsLimit = {
      type: 0,
      show: false,
      lastTime: 0,
      contact: ''
    }
  },
  setCheckReqConfig(state, data) {
    console.warn('---------setCheckReqConfig-----', data)
    state.checkReqConfig = Object.assign({}, state.checkReqConfig, data)
  },
  setEdmMsg(state, data) {
    state.edmMsg = data
  }
}

const getters = {
  // 校验是否有当前元素的权限
  CP: state => key => {
    const { privilege_info } = state.user_info
    if (!privilege_info) return false
    return privilege_info[key] == 'y'
  },
  // 是否已属于某个公司
  isCorp(state) {
    return state.user_info.corp_id
  },
  getValue: state => key => {
    return state[key]
  },
  getCrfastLeft(state) {
    if (!state.user_info || !state.user_info.purchase_product) return 0
    const corpLeft = state.user_info.purchase_product.cr_fast_left
    const userLeft = state.user_info.user_crfast_left
    if (corpLeft > 0) {
      return userLeft == -1 ? corpLeft : userLeft
    }
    return 0
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
